module.exports = __webpack_public_path__ + "img/bemajor-big-2.556690cd.jpg";